import { render, staticRenderFns } from "./OfficesPersonsIcon.vue?vue&type=template&id=025e733b&"
import script from "./OfficesPersonsIcon.vue?vue&type=script&lang=js&"
export * from "./OfficesPersonsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports